import { putPriority } from '../services';
export const updatePriority = (params) => putPriority(params).then(response => formattedData(response?.data));
const formattedData = (response) => {
    return response?.success;
};
